import { useCallback, useEffect, useRef, useState } from 'react'
import SearchBar from '../../../../../../../../baseComponents/SearchBar'
import { twinFetchPostJSON } from '../../../../../../../../utils/globals/data'
import useOnClickOutside from '../../../../../../../../utils/hooks/useOnClickOut'
import SearchBarQuoteCustomerResults from './SearchBarQuoteCustomerResults'
import { OnChangeSearchBarAddQuoteCustomer, QuoteOrderModelTypeExtended } from '../types'
import '../../../../../../../../specificComponents/Product/SearchBarProduct/searchbarproduct.sass'
import { faTimes } from '@fortawesome/pro-light-svg-icons'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import CustomSelect from '../../../../../../../../forms/CustomSelect'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import Checkbox from '../../../../../../../../forms/Checkbox'
import locations from '../../../../../../../../utils/globals/locations'

interface SelectorSearchbarDeciderComponentProps {}

const SearchbarQuoteCustomerDeciderComponent: React.FC<SelectorSearchbarDeciderComponentProps> = () => {
    const { data, setData } = useSelectorSearchbarDeciderComponentLogic()
    const { t } = useTwinTranslation()
    const searchUrl = locations.quoteOrderSingle + '/' + String(data?.id)
    if (data?.id) {
        const nameValue = data?.full_assigned_number + ' - ' + data?.Customer?.name
        return (
            <div className='flex flex-col'>
                <CustomSelect name='OrderId' value={data.id} icon={faTimes} readOnly={true} label={t('quote', 'Presupuesto')} items={{ [data.id]: { name: nameValue } }} onClickIcon={() => setData(null)} className='mt-16' />
                <a href={searchUrl} rel="noreferrer"  target='_blank' className='cursor-pointer text-green-43 ml-auto mt-10'><TwinTrans transKey='showQuote'>Ver presupuesto</TwinTrans></a>
                <Checkbox className='mt-20 block' name='updatePrice' label={t('updatePricesOfProducts', 'Actualizar precios de los productos')} defaultChecked={true}></Checkbox>
                <Checkbox className='mt-20 block' name='updateCopyProduct' label={t('updateNameAndDescriptions', 'Actualizar nombre y descripción de los productos')} defaultChecked={true}></Checkbox>
                <Checkbox className='mt-20 block' name='copyNotes' label={t('copyNotes', 'Copiar notas')} defaultChecked={true}></Checkbox>
            </div>
        )
    }
    return (
        <SearchBarQuoteCustomer className='mt-16' placeholder={t('duplicateQuoteDots', 'Duplicar presupuestos...')} setData={setData} />
    )
}

const useSelectorSearchbarDeciderComponentLogic = () => {
    const [data, setData] = useState<QuoteOrderModelTypeExtended | null>(null)
    return { setData, data}
}

interface SearchBarQuoteCustomerProps extends SearchBarQuoteCustomerLogicProps {
    title?: string
    className?: string
    placeholder?: string
}

const SearchBarQuoteCustomer: React.FC<SearchBarQuoteCustomerProps> = ({ title, className, placeholder, ...rest }) => {
    const { setSearchValue, items, searchValue, ref, myChangeSelectedItems } = useSearchBarQuoteCustomerLogic({ ...rest })
    return (
        <div className={'relative ' + (className || '')} ref={ref}>
            {title ? <span className='block regular18 my-22'>
                {title}
            </span> : null}
            <SearchBar onChange={setSearchValue} {...{ searchValue, placeholder }} />
            {items && <SearchBarQuoteCustomerResults quotes={items} onSelectQuote={myChangeSelectedItems} className='w-full' />}
        </div>
    )
}

interface SearchBarQuoteCustomerLogicProps {
    setData: React.Dispatch<React.SetStateAction<QuoteOrderModelTypeExtended | null >>
}

const useSearchBarQuoteCustomerLogic = ({ setData }: SearchBarQuoteCustomerLogicProps) => {
    const ref = useRef<any>(null)
    const [searchValue, setSearchValue] = useState<string>('')
    const [items, setItems] = useState<QuoteOrderModelTypeExtended[] | null>(null)

    const resetSearchValue = useCallback(() => {
        setSearchValue('')
        setItems(null)
    }, [setSearchValue])

    const myChangeSelectedItems: OnChangeSearchBarAddQuoteCustomer = useCallback((value) => {
        setData(value)
        resetSearchValue()
    }, [setData, resetSearchValue])

    const searchItems = useCallback(async (value: string) => {
        const searchedItems = await twinFetchPostJSON('/api/app/order/quote/getAllQuoteOrdersComplete', {
            needPrices: true,
            where: {
                '$or': {
                    'full_assigned_number': {
                        '$iLike': `%${value}%`
                    },
                    'Customer.name': { '$iLike': `%${value}%` },
                }
            },
            limit: 15
        })
        setItems(searchedItems)
    }, [setItems])


    useOnClickOutside(ref, () => resetSearchValue())


    useEffect(() => {
        if (searchValue !== '') {
            searchItems(searchValue)
        } else {
            setItems(null)
        }
    }, [searchValue, searchItems])

    return { setSearchValue, items, searchValue, resetSearchValue, ref, myChangeSelectedItems }
}

export default SearchbarQuoteCustomerDeciderComponent